import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LngLat } from "../utils/zoneGeometry";
import { NominatimResult, useLocationSearch } from "@/hooks/location/useLocationSearch";
import { useDebounced } from "@/hooks/useDebounced";

/** Nominatim allows about one request per second; typing waits this long before asking. */
const SEARCH_DEBOUNCE_MS = 400;

interface Props {
  label: string;
  onSelect(center: LngLat, label: string): void;
}

export default function AddressSearchField({ label, onSelect }: Props) {
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const debounced = useDebounced(input, SEARCH_DEBOUNCE_MS);
  const { data: results = [], isFetching } = useLocationSearch(debounced);

  return (
    <Autocomplete<NominatimResult>
      size="small"
      options={input.length >= 3 ? results : []}
      filterOptions={options => options}
      getOptionLabel={option => option.display_name}
      isOptionEqualToValue={(a, b) => a.display_name === b.display_name}
      loading={isFetching}
      noOptionsText={input.length < 3 ? t("zonesPage.form.addressMinChars") : t("zonesPage.form.addressNone")}
      onInputChange={(_, value) => setInput(value)}
      onChange={(_, value) => value && onSelect([Number(value.lon), Number(value.lat)], value.display_name)}
      renderInput={params => <TextField {...params} label={label} />}
    />
  );
}
